var ProductCardElement;
var QuickViewButtonElement;
/** Modal quick view atualmente no DOM (estado global do fluxo QuickViewButtonElement). */
var teamdropQuickViewModalRoot = null;
/** Cache do JSON de variantes por nó de cartão (ProductCardElement). */
var teamdropProductCardVariantJsonCache = new WeakMap();

/** Comportamento partilhado add-to-cart / PDP / cartões / quick view (sem theme.product.form). */
window.teamdropProductFormProto = {
  sectionId: "",
  form: null,
  render: function () {
    this.form &&
      ((this.form.querySelector("input[name=id]").disabled = !1),
        this.form.addEventListener("submit", this.submitHandler.bind(this)),
        (this.errorMsgElement = this.form.querySelector(".field-msg")));
  },
  submitHandler: async function (e) {
    e.preventDefault();
    var btn =
      e.submitter ||
      this.form.querySelector('[data-add-to-cart-trigger], .product-form__submit');
    if (!btn) return;

    this.showLoader(btn);
    this.hideErrorMsg();

    try {
      // theme.cart.add() já cuida de: fetch com sections, atualizar counter,
      // injetar HTML do drawer, abrir drawer (ou redirecionar /cart) e disparar cart:added.
      await theme.cart.add(new FormData(this.form));

      // Fecha quickview (se aberto) — o drawer abre por cima.
      var qv = document.querySelector(".product-quickview");
      if (qv) {
        qv.classList.add("fade-out");
        setTimeout(function () {
          qv.remove();
        }, 300);
      }

      // Buy now: ignora o drawer e vai direto pro cart.
      if (btn.classList.contains("buy-now")) {
        window.location.href = "/cart";
      }
    } catch (err) {
      this.handleError(err.message);
    } finally {
      var self = this;
      setTimeout(function () { self.hideLoader(btn); }, 500);
    }
  },
  handleError: function (e = !1) {
    if (!this.errorMsgElement) return;
    var span = this.errorMsgElement.querySelector("span");
    if (span) span.innerHTML = e;
    this.errorMsgElement.classList.remove("d-none");
  },
  hideErrorMsg: function () {
    this.errorMsgElement && this.errorMsgElement.classList.add("d-none");
  },
  showLoader: function (e) {
    theme.utilities.toggleSpinner(e, true);
  },
  hideLoader: function (e) {
    theme.utilities.toggleSpinner(e, false);
  },
  disableBuyButton: function () {
    document.querySelectorAll(".product-form__submit").forEach((e) => {
      e.setAttribute("disabled", !0);
      let t = e.querySelector("span");
      t && (t.textContent = window.accessibilityStrings.soldOut);
    });
  },
  enableBuyButton: function () {
    document.querySelectorAll(".product-form__submit").forEach((e) => {
      e.removeAttribute("disabled");
      let t = e.querySelector("span");
      t &&
        (e.classList.contains("buy-now")
          ? (t.textContent = window.accessibilityStrings.buyNow)
          : (t.textContent = window.accessibilityStrings.addToCart));
    });
  },
};
var teamdropProductFormProto = window.teamdropProductFormProto;

(theme.product = {
  // theme.product.init é mantido vazio para compatibilidade.
  // <product-card> é lazy via Web Component; mainPage roda em product-pdp.js.
  init: function () {},
  customSwatchColors: function () {
    let e = window.themeSettings.productColors.split(","),
      t = {};
    return (
      e.forEach((e) => {
        var i = (e = e.split(":"))[0].trim();
        (e = e[1].trim()), (t[i] = e);
      }),
      t
    );
  },
});

theme.product.quantityInput = {
    wrapper: null,
    element: null,
    render: function () {
      let self = this;
      if (this.wrapper) {
        Array.from(this.wrapper.getElementsByClassName("product-quantity")).forEach(function (container) {
          Array.from(container.getElementsByTagName("button")).forEach(function (btn) {
            btn.addEventListener("click", self.handleOnClick.bind(self));
          });
        });
      }

      if (this.element) {
        this.element.querySelectorAll("button").forEach(function (btn) {
          btn.addEventListener("click", self.handleOnClick.bind(self));
        });
      }
    },
    handleOnClick: function (event) {
      event.preventDefault();

      let input = event.currentTarget.closest(".product-quantity").querySelector("input");
      if ("minus" === event.currentTarget.name && 1 === parseInt(input.value)) {
        let removeBtn = event.currentTarget.closest(".cart-item")?.querySelector(".js-item-remove");
        if (removeBtn) {
          removeBtn.click();
          return;
        }
      }

      if ("plus" === event.currentTarget.name) input.stepUp();
      else input.stepDown();

      this.toggleButton(event.currentTarget);
      input.dispatchEvent(new Event("change"));
    },
    toggleButton: function (button) {
      var input = button.closest(".product-quantity").querySelector("input");
      let minusBtn = button.closest(".product-quantity").querySelector('button[name="minus"]');
      minusBtn.disabled = parseInt(input.value) === 1;
    },
  };

// add-to-cart Web Component (usa teamdropProductFormProto — não duplica submit).
class AddToCartElement extends EssenceBaseComponent {
  get eagerInit() { return true; }

  init() {
    if (!theme || !theme.utilities || !theme.cart || !theme.cart.drawer) return;

    const form = this.resolveForm();
    if (!form) return;

    if (form.dataset.addToCartBound === "true") return;
    form.dataset.addToCartBound = "true";

    const controller = Object.create(teamdropProductFormProto);
    controller.form = form;
    controller.render();

    this.form = form;
    this.controller = controller;
  }

  destroy() {
    if (this.form && this.form.dataset.addToCartBound === "true") {
      delete this.form.dataset.addToCartBound;
    }
    this.form = null;
    this.controller = null;
  }

  resolveForm() {
    if (this.form) return this.form;

    const formId = this.getAttribute("form-id");
    if (formId) {
      const byId = document.getElementById(formId);
      if (byId && byId.tagName === "FORM") return byId;
    }

    const formSelector = this.getAttribute("form-selector");
    if (formSelector) {
      const bySelector = document.querySelector(formSelector);
      if (bySelector && bySelector.tagName === "FORM") return bySelector;
    }

    const nestedForm = this.querySelector("form");
    if (nestedForm) return nestedForm;

    const nearestForm = this.closest("form");
    if (nearestForm) return nearestForm;

    return null;
  }
}

if (window.customElements && !customElements.get("add-to-cart")) {
  customElements.define("add-to-cart", AddToCartElement);
}
// quick-view-btn: resolve trigger irmão e abre quick-view modal.
QuickViewButtonElement = class QuickViewButtonElement extends EssenceBaseComponent {
    get eagerInit() { return true; }

    init() {
      if (!theme || !theme.product) return;

      var trigger = this.resolveTrigger();
      if (!trigger) return;

      this.trigger = trigger;
      this.trigger.dataset.quickViewManaged = "true";

      var attrUrl =
        this.getAttribute("quickview-url") || this.getAttribute("quick-view-url");
      var triggerUrl = this.trigger.dataset.quickViewUrl;
      var resolvedUrl = triggerUrl || attrUrl || "";

      if (resolvedUrl) {
        this.trigger.dataset.quickViewUrl = resolvedUrl;
      }

      this.trigger.addEventListener("click", this.onTriggerClick.bind(this), {
        signal: this.__tdController.signal,
      });
    }

    resolveTrigger() {
      var next = this.nextElementSibling;
      if (next && next.matches("[data-quick-view-trigger]")) return next;

      var attrUrl =
        this.getAttribute("quickview-url") || this.getAttribute("quick-view-url");
      if (!attrUrl)
        return this.parentElement?.querySelector("[data-quick-view-trigger]") || null;

      var byDataUrl = this.parentElement?.querySelector(
        `[data-quick-view-trigger][data-quick-view-url="${attrUrl}"]`
      );
      return (
        byDataUrl ||
        this.parentElement?.querySelector("[data-quick-view-trigger]") ||
        null
      );
    }

    onTriggerClick(event) {
      event.preventDefault();
      if (!this.trigger) return;
      QuickViewButtonElement.openFromButton(this.trigger);
    }

    destroy() {
      if (this.trigger) {
        delete this.trigger.dataset.quickViewManaged;
      }
      this.trigger = null;
    }

    static openFromButton(button) {
      if (!button || !theme || !theme.product) return;

      theme.utilities.toggleSpinner(button, true);
      button.disabled = true;

      var quickviewUrl = button.dataset.quickViewUrl;

      if (!quickviewUrl) {
        QuickViewButtonElement.resetButtonState(button);
        return;
      }

      fetch(window.location.origin + quickviewUrl)
        .then(function (response) {
          if (!response.ok) throw new Error("Erro ao carregar Quick View");
          return response.text();
        })
        .then(function (html) {
          QuickViewButtonElement.showModal(html);
          setTimeout(function () {
            QuickViewButtonElement.resetButtonState(button);
          }, 300);
        })
        .catch(function (error) {
          console.error("Erro ao buscar Quick View:", error);
          QuickViewButtonElement.resetButtonState(button);
        });
    }

    static resetButtonState(button) {
      button.disabled = false;
      theme.utilities.toggleSpinner(button, false);
    }

    static showModal(html) {
      if (teamdropQuickViewModalRoot && teamdropQuickViewModalRoot.parentNode) {
        teamdropQuickViewModalRoot.remove();
      }

      var parsedHTML = new DOMParser().parseFromString(html, "text/html");
      teamdropQuickViewModalRoot = parsedHTML.querySelector(".product-quickview");
      if (!teamdropQuickViewModalRoot) return;

      var sectionId = teamdropQuickViewModalRoot.dataset.sectionId;

      var cartDrawer = document.querySelector("#cartDrawer");
      if (cartDrawer && cartDrawer.classList.contains("activated")) {
        teamdropQuickViewModalRoot.setAttribute("data-from-cart-drawer", "true");
      }

      var productImages = teamdropQuickViewModalRoot.getElementsByClassName("pr-image");

      window._themeProducts = window._themeProducts || {};
      var productDataEl = teamdropQuickViewModalRoot.querySelector(
        '#ProductData[type="application/json"]'
      );
      if (productDataEl && productDataEl.textContent) {
        window._themeProducts[teamdropQuickViewModalRoot.dataset.productId] = JSON.parse(
          productDataEl.textContent
        );
      }

      document.querySelector("body").append(teamdropQuickViewModalRoot);

      // teamdropQuickViewModalRoot já é <modal-element name="quickview" data-modal-dynamic>
      // (vindo de sections/product-quickview.liquid). open() é provido pela classe.
      if (typeof teamdropQuickViewModalRoot.open === "function") {
        teamdropQuickViewModalRoot.open();
      }

      theme.utilities.imagesSrcset(productImages);
      var productForm = teamdropQuickViewModalRoot.querySelector(".product-form");

      var formInstance = Object.create(teamdropProductFormProto);
      formInstance.form = productForm;
      formInstance.render();
      if (typeof Shopify !== "undefined" && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      theme.utilities.applyAnimation();
      var sliderInstance;
      if (theme.product.imageSlider) {
        var sliderCtl = Object.create(theme.product.imageSlider);
        sliderCtl.sliderSelector =
          '.product-quickview[data-section-id="' +
          sectionId +
          '"] .product-media__swiper';
        sliderCtl.productId = teamdropQuickViewModalRoot.dataset.productId;
        sliderCtl.sectionId = teamdropQuickViewModalRoot.dataset.sectionId;
        sliderInstance = sliderCtl.render();
      }

      // Overlay click + close button são tratados automaticamente por <modal-element>.
      // Após o modal:close, o data-modal-dynamic remove o elemento do DOM.
      teamdropQuickViewModalRoot.addEventListener("modal:close", function () {
        teamdropQuickViewModalRoot = null;
      }, { once: true });

      var qvVariantRoot =
        teamdropQuickViewModalRoot.querySelector(".product-variant");
      if (theme.product.variant && qvVariantRoot) {
        var variantCtl = Object.create(theme.product.variant);
        variantCtl.productVariant = qvVariantRoot;
        variantCtl.imageSlider = sliderInstance;
        variantCtl.form = formInstance;
        variantCtl.sections = [
          {
            sectionId: teamdropQuickViewModalRoot.dataset.sectionId,
            selectors: ["#price-" + teamdropQuickViewModalRoot.dataset.sectionId],
          },
        ];
        variantCtl.render();
      }

      teamdropInitTooltips(teamdropQuickViewModalRoot);
    }
  };

if (window.customElements && !customElements.get("quick-view-btn")) {
  customElements.define("quick-view-btn", QuickViewButtonElement);
}

// product-card: lazy via IntersectionObserver (15% do viewport).
// O <add-to-cart> e <quick-view-btn> dentro do card continuam eager —
// se o usuário scroll rápido, eles já estão prontos quando o card aparece.
ProductCardElement = class ProductCardElement extends EssenceBaseComponent {
    init() {
      ProductCardElement.setupCardRoot(this);
    }

    destroy() {
      this.removeAttribute("card-rendered");
    }

    /**
     * Liga comportamento do cartão (forms em grid, swatches) a qualquer raiz .product-card ou <product-card>.
     */
    static setupCardRoot(root) {
      if (!root || !theme || !theme.product) return;
      if (root.hasAttribute("card-rendered")) return;

      var forms = root.querySelectorAll("form");
      if (0 < forms.length) {
        forms.forEach(function (formEl) {
          var ctl = Object.create(teamdropProductFormProto);
          ctl.form = formEl;
          ctl.render();
        });
      }

      var swatches = root.querySelector(".product-card__swatches");
      if (swatches) {
        swatches.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          radio.addEventListener("change", function (ev) {
            ProductCardElement.handleVariantRadioChange(ev, root);
          });
          var label = swatches.querySelector(
            'label[for="' + radio.getAttribute("id") + '"]'
          );
          if (label && label.dataset.swatch) {
            var colorKey = label.dataset.swatch.toLowerCase();
            var mapped = theme.product.customSwatchColors()[colorKey];
            if (mapped) label.style.cssText = "--swatch-background-color: " + mapped;
          }
        });
      }

      root.setAttribute("card-rendered", "");
    }

    static handleVariantRadioChange(ev, root) {
      ev.preventDefault();
      var input = ev.currentTarget;
      var value = input.value;
      var optIndex = parseInt(input.dataset.optionPosition, 10) - 1;
      var rows = ProductCardElement.getVariantData(root);
      var variant = rows.find(function (row) {
        return row.options[optIndex] === value;
      });
      if (!variant) return;

      var cardRoot = input.closest(".product-card") || root;
      cardRoot.querySelectorAll(".variant-img").forEach(function (wrap) {
        wrap.classList.remove("variant-img--active");
      });
      var thumb = cardRoot.querySelector(
        '[data-variant-image="' + variant.id + '"]'
      );
      if (thumb) {
        var inner = thumb.querySelector(".variant-img");
        if (inner) inner.classList.add("variant-img--active");
      }

      root.querySelectorAll("form").forEach(function (formEl) {
        var idInput = formEl.querySelector('input[name="id"]');
        if (idInput) idInput.value = variant.id;
      });
    }

    static getVariantData(root) {
      var cached = teamdropProductCardVariantJsonCache.get(root);
      if (cached) return cached;
      var jsonEl = root.querySelector('[type="application/json"]');
      if (!jsonEl || !jsonEl.textContent) return [];
      var parsed = JSON.parse(jsonEl.textContent);
      teamdropProductCardVariantJsonCache.set(root, parsed);
      return parsed;
    }
  };

if (window.customElements && !customElements.get("product-card")) {
  customElements.define("product-card", ProductCardElement);
}

/**
 * <product-gallery-swiper> — galeria de PDP / featured-product / quickview.
 * Em main-product: data-eager (init imediato).
 * Em featured-product: lazy (15% do viewport via EssenceBaseComponent default).
 * Em product-quickview: data-eager (markup tem o atributo).
 */
function teamdropGetProductJson(root) {
  var productId = root.dataset.productId;
  if (productId && window._themeProducts && window._themeProducts[productId]) {
    return window._themeProducts[productId];
  }
  var qv = root.closest(".product-quickview");
  var script = qv && qv.querySelector("#ProductData[type='application/json']");
  if (!script) script = root.querySelector("#ProductData[type='application/json']");
  if (script && script.textContent) {
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }
  return null;
}

class ProductGallerySwiper extends EssenceBaseComponent {
  init() {
    if (typeof Swiper === "undefined") return;

    this.mainEl = this.querySelector(".product-media__swiper");
    if (!this.mainEl) return;

    this.thumbsEl = this.querySelector(".product-media__nav-swiper");
    var hasThumbs = !!(this.thumbsEl && this.dataset.noThumbs !== "true");

    var sectionId = this.dataset.sectionId || "";
    var initialSlide = this.computeInitialSlide(sectionId);

    var thumbDirection = "horizontal";
    if (this.thumbsEl && this.thumbsEl.dataset.sliderDirection) {
      thumbDirection = this.thumbsEl.dataset.sliderDirection;
    }

    var thumbsModule = false;
    if (hasThumbs) {
      if (!this.thumbsEl.classList.contains("swiper")) this.thumbsEl.classList.add("swiper");
      var spv = thumbDirection === "horizontal" ? 6 : "auto";
      var nextT = this.thumbsEl.querySelector(".swiper-nav-thumbnail-next");
      var prevT = this.thumbsEl.querySelector(".swiper-nav-thumbnail-prev");
      var thumbNav = nextT && prevT ? { nextEl: nextT, prevEl: prevT } : false;

      var applyAnim = function () {
        if (theme && theme.utilities) theme.utilities.applyAnimation();
      };

      this.thumbsSwiper = new Swiper(this.thumbsEl, {
        spaceBetween: 8,
        slidesPerView: spv,
        watchSlidesProgress: true,
        direction: thumbDirection === "horizontal" ? "horizontal" : "vertical",
        navigation: thumbNav,
        breakpoints: {
          768: { slidesPerView: spv, spaceBetween: 12 },
        },
        on: { afterInit: applyAnim, loopFix: applyAnim },
      });
      thumbsModule = { swiper: this.thumbsSwiper };
    }

    if (!this.mainEl.classList.contains("swiper")) this.mainEl.classList.add("swiper");

    var paginationEl = this.mainEl.querySelector(".product-media-pagination");
    var nextMain = this.mainEl.querySelector(".swiper-nav-next");
    var prevMain = this.mainEl.querySelector(".swiper-nav-prev");

    var applyAnimMain = function () {
      if (theme && theme.utilities) theme.utilities.applyAnimation();
    };

    var mainOpts = {
      spaceBetween: 10,
      loop: true,
      initialSlide: initialSlide,
      navigation: nextMain && prevMain ? { nextEl: nextMain, prevEl: prevMain } : false,
      on: { afterInit: applyAnimMain, loopFix: applyAnimMain },
    };

    if (paginationEl) {
      mainOpts.pagination = { el: paginationEl, type: "fraction" };
    }
    if (thumbsModule) mainOpts.thumbs = thumbsModule;

    this.mainSwiper = new Swiper(this.mainEl, mainOpts);
  }

  computeInitialSlide(sectionId) {
    if (!window.location.search.includes("?variant=")) return 0;
    var product = teamdropGetProductJson(this);
    var variant = product && product.selected_or_first_available_variant;
    if (!variant || !variant.featured_media) return 0;
    var mid = variant.featured_media.id;
    var slide = this.mainEl.querySelector(
      '[data-media-id="' + sectionId + "-" + mid + '"]'
    );
    if (!slide || slide.dataset.index === undefined) return 0;
    return parseInt(slide.dataset.index, 10) || 0;
  }

  destroy() {
    if (this.mainSwiper && typeof this.mainSwiper.destroy === "function") {
      this.mainSwiper.destroy(true, true);
    }
    this.mainSwiper = null;
    if (this.thumbsSwiper && typeof this.thumbsSwiper.destroy === "function") {
      this.thumbsSwiper.destroy(true, true);
    }
    this.thumbsSwiper = null;
  }
}

if (window.customElements && !customElements.get("product-gallery-swiper")) {
  customElements.define("product-gallery-swiper", ProductGallerySwiper);
}

// Cards são Web Components com lazy init próprio. Não há trabalho global a fazer aqui:
// teamdropInitProductCards (com setupCardRoot) é chamado apenas em containers AJAX
// (product-recommendations, recent-viewed, wishlist page). PDP mainPage roda no fim
// de product-pdp.js (que carrega só em template product).
